import styled from 'styled-components';

export const NameWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const FormNameWrapper = styled.div`
  display: flex;
  gap: 28px;

  .ant-form-item {
    flex: 1;
  }
`;

export const AdminFormWrapper = styled.div`
  .ant-btn {
    margin-top: 16px;
  }
`;

export const FilterBody = styled.div`
  padding: 14px 16px 16px;

  display: flex;
  flex-direction: column;
  gap: 8px;

  .ant-checkbox-group {
    flex-direction: column;
    gap: 8px;
  }

  .ant-checkbox-wrapper {
    padding: 7px 0;
  }

  .title {
    color: var(--secondary);
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
  }

  .footer {
    width: 100%;
    padding-top: 4px;
  }
`;

export const ActionWrapper1 = styled.div`
  text-align: start;
`;

export const FilterRolesWrapper = styled.div`
  height: 200px;
  overflow: hidden;
`;
